export default __webpack_public_path__ + "static/media/Chancellor Cloak.2fc6b10f.jpg";